import { compose } from 'redux';
import { getIsSeatAvailableByCombineWith } from './getIsSeatAvailableByCombineWith';
import { getIsSeatAvailableByFilters } from './getIsSeatAvailableByFilters';
export function getRowsByGroupWithStates(groups, activeDoubleSeats, selectedFilters) {
    const seatAvailableCompose = compose(getIsSeatAvailableByCombineWith(activeDoubleSeats), getIsSeatAvailableByFilters(Array.from(selectedFilters || [])));
    return groups.map(group => (Object.assign(Object.assign({}, group), { rows: group.rows.map(row => (Object.assign(Object.assign({}, row), { seats: row.seats.map(seatAvailableCompose) }))) })));
}
